import axios from "lib/axios";

const getEvent = async () => {
  const { data } = await axios.get("/event");
  return data;
};

const getEventDetail = async (eventId) => {
  const { data } = await axios.get(`/event/${eventId}`);
  return data;
};

const getEventRegistration = async (eventId) => {
  const { data } = await axios.get(`/event/${eventId}/registration/`);
  return data;
};

const requestOTPRegistration = async ({ phoneNumber, repToken }) => {
  const { data } = await axios.post(
    "/rep/requestClientOtp/",
    { phoneNumber: phoneNumber, repToken }
    // {
    //   headers: {
    //     "reptoken": repToken,
    //   },
    // },
  );
  return data;
};

const submitOTPRegistration = async ({ otp, otpToken, repToken }) => {
  const { data } = await axios.post("rep/submitClientOtp", {
    otp: otp,
    otpToken,
    repToken,
  });
  return data;
};

const submitCardNameUser = async ({ clientId, cardName, repToken }) => {
  const { data } = await axios.post("rep/client/cardName", {
    clientId,
    cardName,
    repToken,
  });
  return data;
};

const submitNationalIdUser = async ({
  clientId,
  birthDate,
  nationalId,
  repToken,
}) => {
  const { data } = await axios.post("rep/client/nationalId", {
    clientId,
    birthDate,
    nationalId,
    repToken,
  });
  return data;
};

const requestFinalizeRegister = async ({ clientId, repToken }) => {
  const { data } = await axios.post("rep/client/finalize", {
    clientId,
    repToken,
  });
  return data;
};

const requestRemoveUser = async ({ clientId, repToken }) => {
  const { data } = await axios.post("rep/client/remove", {
    clientId,
    repToken,
  });
  return data;
};

export {
  getEvent,
  getEventDetail,
  getEventRegistration,
  requestOTPRegistration,
  submitOTPRegistration,
  submitCardNameUser,
  submitNationalIdUser,
  requestFinalizeRegister,
  requestRemoveUser,
};
